export default __webpack_public_path__ + "static/media/Menu_T-shirt.1cd09c1c.svg";